export default __webpack_public_path__ + "static/media/flinksCapital.45eb4577.svg";